import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'TrendingVideo_v2' */ './TrendingVideo'),
  loading: () => null,
});

export default class WithTrendingVideo extends React.Component {
  render() {
    return <LoadableComponent {...this.props} />;
  }
}
